// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"302b339d","455":"1c349418","977":"66b0db07"}[chunkId] + ".chunk.js";
};